import { useState } from 'react';
import { Box } from '@mantine/core';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import EmailForm from './EmailForm';

const EmailsDetailsForm = ({ onUpdate, onDelete, onBack, onDuplicate, email, showUserFlow = null }) => {
  const fetch = useFetch();

  const [userError, setUserError] = useState();
  const [deleteError, setDeleteError] = useState();
  const [loading, setLoading] = useState(false);
  const { accountId, domainId } = useParams();

  const update = (email, redirect, cb) => {
    setLoading(true);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/emails/${email.id}`, {
      method: 'PUT',
      body: JSON.stringify(email),
    })
      .then(() => {
        onUpdate(redirect);
        if (typeof cb === 'function') {
          cb();
        }
      })
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/emails/${email.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        onDelete();
        if (typeof cb === 'function') {
          cb();
        }
      })
      .catch(setDeleteError);
  };

  if (!email) {
    return <Spinner />;
  }

  return (
    <>
      <EmailForm
        loading={loading}
        email={email}
        saveEmail={update}
        deleteEmail={onDelete ? del : null}
        onBack={onBack}
        onDuplicate={onDuplicate}
        showUserFlow={showUserFlow ? () => showUserFlow() : null}
        deleteError={deleteError?.message}
      />
      {userError ? (
        <Box ta="left">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default EmailsDetailsForm;
